import { useState } from 'react'
import PageWrapper from '../../../../components/Pagewrapper'
import type { PageTab } from '../../../../types/internal-types'
import LegacySwapsScreen from './LegacySwapsScreen'
import ProfileScreen from './ProfileScreen'

function AccountScreen() {
  const [tab, setTab] = useState<'profile' | 'settings' | 'legacy-swaps'>(
    'profile'
  )

  const tabs: PageTab[] = [
    {
      title: 'Profile',
      onPress: () => setTab('profile'),
      active: tab === 'profile',
    },
    {
      title: 'Legacy Swaps',
      onPress: () => setTab('legacy-swaps'),
      active: tab === 'legacy-swaps',
    },
  ]

  return (
    <PageWrapper
      title="Account"
      tabs={tabs}
      fixedWidth
      description="Change your settings and personal details."
    >
      {tab === 'profile' && <ProfileScreen />}
      {tab === 'legacy-swaps' && <LegacySwapsScreen />}
    </PageWrapper>
  )
}

export default AccountScreen
